enum IReqResponseCode {
  DecodeError = -2,
  HeaderParamsMiss = -1,
  NoEncryption = 1,
  Encryption = 2,
  ClientError = 4,
  ServerError = 5,
}

enum IReqResponseMode {
  NoEncryption = 0,
  FieldEncrypt = 1,
  BodyEncrypt = 2,
}

enum JsonPathLabelType {
  JsonPathLabelType_Normal,
  JsonPathLabelType_Array,
  JsonPathLabelType_Map,
}

const jsonPathLabels = {
  '<idx>': JsonPathLabelType.JsonPathLabelType_Array,
  '<id>': JsonPathLabelType.JsonPathLabelType_Map,
  '<norm>': JsonPathLabelType.JsonPathLabelType_Map,
  '<form>': JsonPathLabelType.JsonPathLabelType_Map,
  '<cn_key>': JsonPathLabelType.JsonPathLabelType_Map,
};

enum JsonNodeType {
  JsonNodeType_Null,
  JsonNodeType_Normal,
  JsonNodeType_Object,
  JsonNodeType_Array,
  JsonNodeType_Map,
  JsonNodeType_JsonString,
}

enum JsonNodeBasicType {
  V_STRING,
  V_ARRAY,
  V_OBJECT,
  V_OTHER,
}

// 抖音APPID
const DOUYIN_APPID = 1128;

export {
  IReqResponseCode,
  IReqResponseMode,
  JsonPathLabelType,
  jsonPathLabels,
  JsonNodeType,
  JsonNodeBasicType,
  DOUYIN_APPID
};
